<template>
    <div class="result_row">
        <div class="row_title">
            {{ $t('search.clinicalResearches') }}
        </div>
        <div class="links_wrapper flex">
            <div
                v-for="(
                    clinicalResearchCategory, index
                ) in clinicalResearchCategories?.rows"
                :key="index"
                class="link_row"
            >
                <nuxt-link
                    :to="
                        localePath(
                            `/clinical-researches/categories/${clinicalResearchCategory.slug}`
                        )
                    "
                    class="link"
                >
                    <div class="title">
                        {{ clinicalResearchCategory.title }}
                    </div>
                </nuxt-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        clinicalResearchCategories: {
            type: Object,
            required: true
        }
    }
};
</script>
